var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroShapes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "square-animation-up",
    x: 200,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#6E00FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "square-animation-up",
    x: 300,
    y: 100,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#C4C4C4",
    fillOpacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "square-animation-scale",
    x: 100,
    y: 100,
    width: 100,
    height: 100,
    rx: 10,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "square-animation-scale",
    y: 200,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#C4C4C4",
    fillOpacity: 0.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "square-animation-up",
    x: 200,
    y: 200,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#6E00FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "square-animation-scale",
    x: 100,
    y: 300,
    width: 100,
    height: 100,
    rx: 10,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "square-animation-up",
    x: 200,
    y: 100,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#FF64CB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "square-animation-scale",
    x: 100,
    y: 200,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#00F7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroShapes);
export default __webpack_public_path__ + "static/media/hero-shapes.0b19462849a295687456840448d27e06.svg";
export { ForwardRef as ReactComponent };